var map = {
	"./0.png": 64162,
	"./1.png": 954667,
	"./2.png": 40848,
	"./3.png": 47097,
	"./4.png": 444678,
	"./5.png": 26223,
	"./6.png": 4756,
	"./7.png": 225885,
	"./8.png": 415114,
	"./9.png": 630675,
	"./dian.png": 385172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 277209;